module.exports = __webpack_public_path__ + "static/media/so.344fe773.jpg";